"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var defaultStyles_1 = require("./defaultStyles");
var themes = Object.keys(defaultStyles_1.defaultStyles).reduce(function (prev, curr) {
    var _a;
    return (__assign(__assign({}, prev), (_a = {}, _a[curr] = [curr], _a)));
}, {});
var styles = defaultStyles_1.defaultStyles;
var styledString = {
    /**
     * Default styles
     * reset, bright, dim, underscore, blink, reverse, hidden, fg_black, fg_red, fg_green, fg_yellow, fg_blue, fg_magenta, fg_cyan, fg_white, fg_crimson, fg_gray, fg_b_red, fg_b_green, fg_b_yellow, fg_b_blue, fg_b_magenta, fg_b_cyan, fg_b_white, fg_b_crimson, bg_black, bg_red, bg_green, bg_yellow, bg_blue, bg_magenta, bg_cyan, bg_white, bg_crimson, bg_gray, bg_b_red, bg_b_green, bg_b_yellow, bg_b_blue, bg_b_magenta, bg_b_cyan, bg_b_white, bg_b_crimson
     * @param customStyles
     */
    setThemes: function (customStyles) { return (themes = __assign(__assign({}, themes), customStyles)); },
    setStyles: function (customColors) { return (styles = __assign(__assign({}, styles), customColors)); },
    listThemes: function () { return themes; },
    listStyles: function () { return styles; },
    styleString: function (str) {
        var styledBlocks = str
            .split("[")
            .map(function (str) { return str.split("]")[0]; })
            .filter(function (str) { return str; });
        return styledBlocks.reduce(function (prev, curr) {
            if (!curr.includes(":"))
                return str;
            var _a = curr.split(":"), themeName = _a[0], theRest = _a.slice(1);
            var stylings = themes[themeName];
            return !stylings
                ? prev
                : prev.replace("[" + curr + "]", stylings.map(function (str) { return "\x1b[" + styles[str] + "m"; }).join("") + theRest.join(":").trim() + "\x1b[0m");
        }, str);
    },
};
styledString.setThemes({ test: [""] });
exports.default = styledString;
